import React from "react";
import styles from "./CategoriesWithAssistantsList.module.scss";

const CategoriesWithAssistantsList = ({
  categories,
  getAssistantName,
  setSelectedCategory,
  selectedCategory,
}) => {
  const categoriesWithAssistants = React.useMemo(() => {
    return categories
      .filter(
        (category) =>
          category.assistantId &&
          category.assistantId !== "00000000-0000-0000-0000-000000000000"
      )
      .map((category) => ({
        id: category.id,
        name: category.name,
        assistantId: category.assistantId,
        assistantName: getAssistantName(category.assistantId),
        sort: category.sort,
      }))
      .sort((a, b) => a.sort - b.sort);
  }, [categories, getAssistantName]);

  if (categoriesWithAssistants.length === 0) {
    return <div>Нет воронок с назначенными ассистентами</div>;
  }

  const handleClick = (val) => {
    const selected = categories.find((category) => category.id === val);
    setSelectedCategory(selected);
  };

  return (
    <div className={styles.container}>
      <h3>Воронки с назначенными ассистентами</h3>
      <ul className={styles.itemsContainer}>
        {categoriesWithAssistants.map((category) => (
          <li
            key={category.id}
            className={styles.item}
            onClick={() => handleClick(category.id)}
          >
            <div
              className={
                selectedCategory.id === category.id ? styles.active : ""
              }
            >
              {category.name}
            </div>{" "}
            {/*- {category.assistantName} */}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CategoriesWithAssistantsList;
